import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcPolicies = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M17.643 9.61c.461-.623.857-1.43.857-2.38v-1h.97c.845 0 1.53.685 1.53 1.53V21.7a1.53 1.53 0 0 1-1.53 1.53H4.53A1.53 1.53 0 0 1 3 21.7V7.76c0-.845.685-1.53 1.53-1.53h.97v1c0 .95.396 1.757.857 2.38.462.622 1.056 1.151 1.629 1.58 1.145.858 2.42 1.475 3.034 1.75a2.384 2.384 0 0 0 1.96 0c.614-.275 1.889-.892 3.034-1.75.573-.429 1.167-.958 1.629-1.58ZM7 15.23a1 1 0 1 0 0 2h10a1 1 0 1 0 0-2H7Zm0 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z",
  fill: "var(--mds-nav-icon-weak)",
  fillRule: "evenodd"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M7.804 1.57A.999.999 0 0 0 7 2.547V7.23c0 2.086 3.482 3.825 4.635 4.342a.884.884 0 0 0 .73 0C13.517 11.056 17 9.316 17 7.23V2.548a.999.999 0 0 0-.804-.979L12.392.81a2 2 0 0 0-.784 0l-3.804.76Zm6.903 3.618a1 1 0 0 0-1.414-1.415L11.25 5.816l-.543-.543a1 1 0 0 0-1.414 1.415l1.25 1.25a1 1 0 0 0 1.414 0l2.75-2.75Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcPolicies");

export { IcPolicies };
//# sourceMappingURL=ic-policies.js.map
